/**
 * loadingMap / errorMap keys for the photo-analysis flow.
 *
 * In their own module, with no imports of their own, purely to keep
 * ImageAnalyzeDb and ImageAnalyzeThunk out of a circular import. The slice
 * needs the thunks (its extraReducers reference `analyzeSingleImage.pending` at
 * module-evaluation time), and the thunks need these keys for their `condition`
 * guards — so pointing the two files at each other would create a cycle whose
 * safety depends entirely on which module the bundler happens to evaluate
 * first. That tends to survive dev and break in a production chunk split.
 *
 * ImageAnalyzeDb re-exports both, so callers keep importing them from the slice
 * alongside its actions, the same way NineSetupDb exposes its own row keys.
 *
 * Both are scoped, never global. Batches may run concurrently, and one image's
 * retry must not grey out every other tile — a single shared key would do both.
 */

export const analyzeBatchKey = (setupId: string, batchId: string): string =>
  `analyzeBatch_${setupId}_${batchId}`;

export const analyzeImageKey = (setupId: string, imageId: string): string =>
  `analyzeImage_${setupId}_${imageId}`;
